import React, { Component } from 'react';
import config from './../../../../config';
import ClickToChartImage from '../ClickToChartImage/ClickToChartImage';
import ChartActions from '../ChartActions/ChartActions';
import { ChartDummyContainer, ChartDummyImage } from './ChartDummy.styled';

interface IChartDummyProps {
   id: string;
   name: string;
}

export default class ChartDummy extends Component<IChartDummyProps, {}> {
   public render() {
      const { id, name } = this.props;
      return (
         <ChartDummyContainer>
            <ChartDummyImage src={`${config.baseName}/images/ChartDummy.png`} id='dummychart' width='500' height='333' />
            <ChartActions id={id} allowExport={false} name={name} chartType='' collectionId='' />
            <ClickToChartImage id={'dummy-note-click-to-chart'} />
         </ChartDummyContainer>
      );
   }
}
